import React from 'react'
import { Box } from '@mui/joy';
import Bidders from '../../blocks/customer/Bidders';
import Breadcrumb from '../../component/common/Breadcrumb';

const BiddersFilter = () => {
    return (
        <>
         <Box
                sx={{
                    width: '100%',
                    height:"100%",
                    maxWidth: 1207,
                    margin: 'auto',
                    padding: '0',
                    backgroundColor: '#ffffff',
                    boxSizing: 'border-box',
                  
                }}
            >
                <Breadcrumb title="Bidders"/>
               
                <Bidders/>
            </Box>

        </>
    )
}

export default BiddersFilter;